export const allowedCompanies = [10201, 12087, 12108, 11188, 12201, 12259, 12334, 12316];
export const allowedCompaniesExceptDemo = [10201, 12087, 12108, 11188, 12259, 12334, 12316, 12201];

export const ytopaEnabled = [10262, 10202, 12736, 12777, 11962]; //not used anymore. Switched to --> packageObj?.features?.youtube_opa?.quota
export const insightsGenieAccess = [10202, 10262, 10614];
